module.exports = __webpack_public_path__ + "img/lambus_logo_rounded-dark@3x.104ca1f.png";